import React, { FunctionComponent } from 'react';
import ISection from '../../../../../../../model/ISection';
import SectionStatesWrapper from '../../../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import SelectedColorOption from './selectedFeatureOption/SelectedColorOption';
import { useSelectedFeatures } from '../../../../../../../hooks/features/useSelectedFeatures';
import IFeatureSections from '../../../../../../../model/IFeatureSections';
import SelectedAccessoryPackOptionsList from './selectedFeatureOption/SelectedAccessoryPackOptionsList';
import SelectedAccessoryOptionsList from './selectedFeatureOption/SelectedAccessoryOptionsList';
import useCustomizeCarContext from '../../../../../../../hooks/useCustomizeCarContext';

const SelectedFeaturesContainer: FunctionComponent = () => {
  const { loading, error } = useCustomizeCarContext();
  const { selectedFeatures } = useSelectedFeatures();

  const getFeaturesComponents = (section: ISection) => {
    switch (section.code) {
      case IFeatureSections.EXTERIOR:
      case IFeatureSections.INTERIOR: {
        return (
          <SelectedColorOption key={section.code} featuresList={section.featuresList} sectionName={section.code} />
        );
      }
      case IFeatureSections.ACCESSORY_PACK: {
        return (
          <SelectedAccessoryPackOptionsList
            key={section.code}
            featuresList={section.featuresList}
            sectionName={section.code}
          />
        );
      }
      case IFeatureSections.ACCESSORY: {
        return (
          <SelectedAccessoryOptionsList key={section.code} sectionName={section.code} categories={section.categories} />
        );
      }
      default:
        return null;
    }
  };

  return (
    <SectionStatesWrapper error={error} loading={loading}>
      {selectedFeatures.map(feature => getFeaturesComponents(feature))}
    </SectionStatesWrapper>
  );
};
export default SelectedFeaturesContainer;
